import { useState, useEffect } from 'react';
import useAdminTokenCheck from 'src/hooks/useAdminTokenCheck';
import adminApi from 'src/lib/adminApi';
import { useHistory, useParams } from 'react-router-dom';
import { format } from 'date-fns';

const templates = {
    CRA: {
        name: "Webinář CRA",
        videoUrl: "",
        startDate: "",
        startTime: "00:00",
        minutesLength: 60,
        partnerGraphicsBannerUrl: "",
        backgroundUrl: "https://webinare.jakub.dev/uploads/gray.png",
        hexColor: "#f59c04"
    },
    DELL: {
        name: "Webinář DELL",
        videoUrl: "",
        startDate: "",
        startTime: "00:00",
        minutesLength: 60,
        partnerGraphicsBannerUrl: "https://webinare.jakub.dev/uploads/dt.png",
        backgroundUrl: "https://webinare.jakub.dev/uploads/pozadi-hexa1.jpg",
        hexColor: "#3074bc"
    }
}

export default function WebinarAdd() {
    const [formValues, setFormValues] = useState(templates.DELL);

    const [selectedFile, setSelectedFile] = useState("");
    const [webinarId, setWebinarId] = useState<number | null>();
    const [selectedBackground, setSelectedBackground] = useState("");
    const [error, setError] = useState<null | string>(null);

    const adminToken = useAdminTokenCheck();
    const history = useHistory();

    const { id } = useParams();

    /* Load the webinar info */
    const loadData = async () => {
        const data = await adminApi.getWebinarDetail(adminToken, id as number);
        const { webinar } = data;
        console.log(webinar);
        const start = new Date(webinar.start);
        const startDate = format(start, "yyyy-MM-dd");
        const startTime = format(start, "HH:mm");

        setFormValues({
            name: webinar.name,
            videoUrl: webinar.videoUrl as string,
            startDate,
            startTime,
            minutesLength: webinar.minutesLength,
            partnerGraphicsBannerUrl: webinar.partnerGraphicsBannerUrl as string,
            backgroundUrl: webinar.backgroundUrl as string,
            hexColor: webinar.hexColor
        });

        setWebinarId(webinar.id);

        document.title = `Úprava - ${webinar.name}`;
    }

    useEffect(() => {
        loadData()
    }, []);

    const webinarInputChange = (e) => {
        setFormValues({ ...formValues, [e.target.name]: e.target.value });
    }

    const fileChange = (e) => {
        setSelectedFile(e.target.files[0]);
    }

    const backgroundFileChange = (e) => {
        setSelectedBackground(e.target.files[0]);
    }

    const formSubmit = async (e) => {

        if (!webinarId) return;

        let formValuesToSubmit = formValues;

        if (selectedFile) {
            const formData = new FormData();
            formData.append("file", selectedFile);
            let url = await adminApi.uploadFile(adminToken, formData);
            formValuesToSubmit["partnerGraphicsBannerUrl"] = url;
        }

        if (selectedBackground) {
            const formData = new FormData();
            formData.append("file", selectedBackground);
            let url = await adminApi.uploadFile(adminToken, formData);
            formValuesToSubmit["backgroundUrl"] = url;
        }

        const result = await adminApi.editWebinar(adminToken, webinarId, formValuesToSubmit);

        setError(result);

        if (!error) {
            history.push(`/admin/webinars/`);
        }
    }

    const setTemplate = (template) => {
        setFormValues(templates[template]);
    }

    return <div className="pb-5">
        <h1>Upravit webinář {webinarId} - {formValues.name}</h1>

        <label className="w-100">Šablona:</label>
        <button className="btn btn-success" onClick={() => setTemplate("DELL")}>DELL</button>
        <button className="btn btn-warning text-white ml-3" onClick={() => setTemplate("CRA")}>CRA</button>

        <p>{error}</p>
        <label>Název webináře*</label>
        <input className="form-control mb-3" type="text" name="name" value={formValues.name} onChange={webinarInputChange}></input>

        <label>Datum webináře*</label>
        <input className="form-control mb-3" type="date" name="startDate" onChange={webinarInputChange} value={formValues.startDate}></input>

        <label>Start webináře*</label>
        <input className="form-control mb-3" type="time" name="startTime" onChange={webinarInputChange} value={formValues.startTime}></input>

        <label>Délka webináře v minutách*</label>
        <input className="form-control mb-3" type="number" name="minutesLength" defaultValue="60" onChange={webinarInputChange} value={formValues.minutesLength}></input>

        <label>Loga vedle webináře - <a href={formValues.partnerGraphicsBannerUrl} target="BLANK">Aktuální</a></label>
        <input className="form-control mb-3" type="file" name="file" onChange={fileChange}></input>

        <label>Pozadí - <a href={formValues.backgroundUrl} target="BLANK">Aktuální</a></label>
        <input className="form-control mb-3" type="file" name="file" onChange={backgroundFileChange}></input>

        <label>Odkaz na video - pouze poslední část URL, například https://www.youtube.com/watch?v=<strong>dQw4w9WgXcQ</strong> nebo https://youtu.be/<strong>dQw4w9WgXcQ</strong></label>
        <input className="form-control mb-3" type="text" name="videoUrl" value={formValues.videoUrl} onChange={webinarInputChange}></input>

        <label>Barva webináře - Výchozí: {formValues.hexColor}</label>
        <input className="form-control form-control-color" type="color" id="hexColor" name="hexColor" onChange={webinarInputChange} value={formValues.hexColor}></input>

        <br />

        <button className="btn btn-warning text-white" onClick={formSubmit}>Upravit webinář</button>
    </div>
}